 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A0_COVER from '@/components/00_Cover'
 import EBB from '@/components/EBB'
 import TLU from '@/components/TLU'
 import MM from '@/components/MM'
 import LOVE1 from '@/components/love1'
 import TITLEPAGE from '@/components/Titlepage'
 import A3_DEDICATION2 from '@/components/03_Dedication2'
 import A7815040788181 from '@/components/97815040788181'
 import A7815040788182 from '@/components/97815040788182'
 import A7815040788183 from '@/components/97815040788183'
 import A7815040788184 from '@/components/97815040788184'
 import A7815040788185 from '@/components/97815040788185'
 import A7815040788186 from '@/components/97815040788186'
 import A7815040788187 from '@/components/97815040788187'
 import A7815040788188 from '@/components/97815040788188'
 import A7815040788189 from '@/components/97815040788189'
 import A78150407881810 from '@/components/978150407881810'
 import A78150407881811 from '@/components/978150407881811'
 import A78150407881812 from '@/components/978150407881812'
 import A78150407881813 from '@/components/978150407881813'
 import A78150407881814 from '@/components/978150407881814'
 import A78150407881815 from '@/components/978150407881815'
 import LOVE2 from '@/components/love2'
 import A78150407881816 from '@/components/978150407881816'
 import PREVIEWPREVIEW from '@/components/Preview/preview'
 import PREVIEWCOVER from '@/components/Preview/cover'
 import PREVIEW03_PROLOGUE from '@/components/Preview/03_Prologue'
 import PREVIEW05_PT1_CHAPTER01 from '@/components/Preview/05_Pt1_chapter01'
 import PREVIEW06_PT1_CHAPTER02 from '@/components/Preview/06_Pt1_chapter02'
 import AUTHORBIO from '@/components/authorbio'
 import COPYRIGHT from '@/components/copyright'
 import SERIESBACKAD from '@/components/seriesbackad'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/00_Cover",
 			"name" : "00_Cover",
 			"component" : A0_COVER
 		},
 		{
 			"path" : "/EBB",
 			"name" : "EBB",
 			"component" : EBB
 		},
 		{
 			"path" : "/TLU",
 			"name" : "TLU",
 			"component" : TLU
 		},
 		{
 			"path" : "/MM",
 			"name" : "MM",
 			"component" : MM
 		},
 		{
 			"path" : "/love1",
 			"name" : "love1",
 			"component" : LOVE1
 		},
 		{
 			"path" : "/Titlepage",
 			"name" : "Titlepage",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/03_Dedication2",
 			"name" : "03_Dedication2",
 			"component" : A3_DEDICATION2
 		},
 		{
 			"path" : "/97815040788181",
 			"name" : "97815040788181",
 			"component" : A7815040788181
 		},
 		{
 			"path" : "/97815040788182",
 			"name" : "97815040788182",
 			"component" : A7815040788182
 		},
 		{
 			"path" : "/97815040788183",
 			"name" : "97815040788183",
 			"component" : A7815040788183
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js